import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Modal } from 'sa-ui';
import messages from './simulatedCorrectionEditConfirmModalMessages';

function getMessage(error) {
  switch (true) {
    case /Answer sheet not found/g.test(error):
      return messages.errorNotFound;
    case /There is no answers to update/g.test(error):
      return messages.errorNoUpdate;
    case error === undefined:
      return messages.successMessage;
    default:
      return messages.successMessage;
  }
}

const SimulatedCorrectionEditConfirmModal = props => {
  const message = getMessage(props.error);
  return (
    <Modal
      show={props.show}
      title={props.intl.formatMessage(messages.title)}
      message={props.intl.formatMessage(message)}
      onClose={props.onClose}
      icon="ti-thumbs-up"
      buttons={[{ onClick: props.onClose, label: props.intl.formatMessage(messages.close) }]}
    />
  );
};

SimulatedCorrectionEditConfirmModal.propTypes = {};

export default injectIntl(SimulatedCorrectionEditConfirmModal);
